<template>
  <div
    class="login-bg"
    :style="{ backgroundImage: 'url(/assets/screen-promo.webp)' }"
  >
    <button
      type="button"
      class="auth-home-btn"
      aria-label="Home"
      title="Home"
      @click="$router.push('/home')"
    >
      <i class="fas fa-home" aria-hidden="true"></i>
    </button>
    <div
      class="login-cont container"
      style="height: 80vh;"
    >
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(15, 36, 23, 0.88);border-radius: 16px;box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);border: 1px solid rgba(0, 242, 61, 0.35);"
          >
            <div class="col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>
                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.name }}</small>
                <div class="form-group mb-3">
                  <label style="color: #00f23d; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.username')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #091a10 !important; color: #f1fff5; box-shadow: none; border-radius: 8px; border: 1px solid rgba(0, 242, 61, 0.45); font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>

                <div class="form-group mb-3 pt-3">
                  <small class="text-dark">{{ errors.phone }}</small>
                  <label style="color: #00f23d; font-weight: 550; letter-spacing: 0.5px;">{{ $t('setting.phone')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #091a10 !important; color: #f1fff5; box-shadow: none; border-radius: 8px; border: 1px solid rgba(0, 242, 61, 0.45); font-size: 1.2rem;"
                    type="text"
                    v-model="phone"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #00f23d; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: #091a10 !important; color: #f1fff5; box-shadow: none; border-radius: 8px; border: 1px solid rgba(0, 242, 61, 0.45); font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #00f23d;"
                      v-if="isShowPassword"
                      @click="showablePassword('password')"
                    ></i>
                    <i
                      v-if="!isShowPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #00f23d;"
                      @click="showablePassword('password')"
                    ></i>
                  </div>
                </div>
                <small class="text-dark">{{ errors.confirm_password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #00f23d; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.confirm_password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: #091a10 !important; color: #f1fff5; box-shadow: none; border-radius: 8px; border: 1px solid rgba(0, 242, 61, 0.45); font-size: 1.2rem;"
                      type="password"
                      ref="confirm_password"
                      v-model="confirm_password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #00f23d;"
                      v-if="isShowConfirmPassword"
                      @click="showablePassword('confirm_password')"
                    ></i>
                    <i
                      v-if="!isShowConfirmPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #00f23d;"
                      @click="showablePassword('confirm_password')"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <div class="auth-secondary-row mt-4 mb-2">
                  <button
                    type="button"
                    class="btn my-0 auth-action-btn auth-action-btn--primary"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.sign_up') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                  <button
                    type="button"
                    class="btn auth-action-btn auth-action-btn--quick auth-action-btn--quick-icon"
                    :aria-label="$t('auth.quick_login')"
                    :title="$t('auth.quick_login')"
                    @click="quickLogin"
                  >
                    <i
                      v-if="!isQuickLogin"
                      class="fas fa-bolt"
                    ></i>
                    <Loading
                      v-else
                      color="#14321c"
                      size="18"
                      class="px-0 py-0"
                    />
                  </button>
                </div>
                <div class="col-12 d-flex my-1">
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(0, 242, 61, 0.45); height: 0;"
                  ></div>
                  <div
                    class="my-auto px-3"
                    style="color: #00f23d;"
                  >OR</div>
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(0, 242, 61, 0.45); height: 0;"
                  ></div>
                </div>
                <div class="text-center mb-3">
                  <button
                    type="button"
                    class="btn my-2 auth-action-btn auth-action-btn--secondary"
                    @click="$router.push('/auth/login')"
                  >
                    {{ $t('auth.login') }}
                  </button>
                </div>
                <!-- <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto divider-line"></div>
                      <div class="my-auto divider-text px-3">OR</div>
                      <div class="col-5 p-0 my-auto divider-line"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #00a82d; color: white; border-radius: 20px; width: 10rem; box-shadow: none;"
                        @click="$router.push('/auth/login')"
                      >
                        <div>
                          {{$t('auth.login')}}
                        </div>
                      </button>
                    </div> -->
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>

              <div class="auth-contact-wrap">
                <p class="auth-contact__hint">
                  {{ $store.state.language === 'en' ? 'Need help?' : 'အကူအညီလိုပါသလား' }}
                </p>
                <div class="row auth-contact-row mx-0">
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile"
                      :href="loginViberHref"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--viber">
                        <i class="fab fa-viber"></i>
                      </span>
                      <span class="auth-contact__title">Viber</span>
                    </a>
                  </div>
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile auth-contact--telegram"
                      :href="telegramLink(loginTelegram)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--telegram">
                        <i class="fab fa-telegram-plane"></i>
                      </span>
                      <span class="auth-contact__title">{{ loginTelegramLabel }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions, mapMutations } from 'vuex';
import { viberLink, telegramLink } from '@/utils/contactLinks';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      error: false,
      errors: {},
      isSignin: false,
      isQuickLogin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
      defaultTelegram: 'https://t.me/Shwekyarphyu168_Bot',
      defaultViber: 'https://msng.link/o?959677640761=vi',
    };
  },
  computed: {
    loginTelegram() {
      return this.$store.state.contactTelegram || this.defaultTelegram;
    },
    loginViberHref() {
      if (this.$store.state.contactInfo) {
        return viberLink(this.$store.state.contactInfo);
      }
      return this.defaultViber;
    },
    loginTelegramLabel() {
      const value = this.loginTelegram;
      if (String(value).startsWith('@')) {
        return value;
      }
      if (String(value).includes('t.me/')) {
        const handle = String(value).split('t.me/').pop().split(/[?#]/)[0];
        return handle ? `@${handle}` : 'Telegram';
      }
      return `@${value}`;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapMutations(['setContactInfo', 'setContactTelegram']),
    telegramLink,
    showablePassword(ref) {
      if (ref === 'password') {
        if (this.isShowPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowPassword = !this.isShowPassword;
      } else {
        if (this.isShowConfirmPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowConfirmPassword = !this.isShowConfirmPassword
      }
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    async quickLogin() {
      this.isQuickLogin = true;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
          referralCode: localStorage.getItem('referralCode'),
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        await this.fetchUser();
        this.$router.push('/home');
        Toast.success('Success!');
      } catch (err) {
        Toast.fail(this.$t('auth.fail_message'));
      }
      this.isQuickLogin = false;
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      console.log('1')
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Required Phone'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Required Confirm Password'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }
      console.log('2')
      try {
        const res = await this.axios.post(
          '/auth/register',
          {
            user_name: this.name,
            phone: this.phone,
            password: this.password,
            confirmPassword: this.confirm_password,
            roles: 'normal',
            referralCode: localStorage.getItem('referralCode'),
            // code: localStorage.getItem('fcm'),
          },
        );
        localStorage.setItem('username', this.phone);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);


        await this.fetchUser();
        this.$router.push('/auth/login');

        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async fetchWebsiteContact() {
      try {
        const res = await this.axios.get('/website-infos');
        const info = res.data.data[0];
        if (!info) return;
        this.setContactInfo(info.contact_info);
        this.setContactTelegram(
          info.telegram_info
            || info.contact_telegram
            || info.telegram
            || info.telegram_link
            || null
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.fetchWebsiteContact();
    if (this.$route.query.code) {
      localStorage.setItem('referralCode', this.$route.query.code);
    }
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: #06110b;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-home-btn {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  right: auto;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.4rem;
  height: 3.4rem;
  border: 1px solid rgba(255, 243, 160, 0.7);
  border-radius: 50%;
  background: linear-gradient(145deg, #fff59d 0%, #ffd000 45%, #f5b800 100%);
  color: #1a2e12;
  box-shadow: 0 6px 18px rgba(255, 208, 0, 0.45);
  cursor: pointer;
}

.auth-home-btn:active {
  transform: scale(0.94);
}

.auth-home-btn i {
  font-size: 1.35rem;
}

.login-bg .form-control,
.login-bg .form-control:focus,
.login-bg .form-control:active,
.login-bg input,
.login-bg input:focus,
.login-bg input:active {
  box-shadow: none !important;
  outline: none !important;
}

.login-cont {
  padding-top: 3rem;
}

.divider-line {
  border-top: 1px solid rgba(255, 255, 255, 0.6);
  height: 0;
}

.divider-text {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: #fff;
  border: 1px solid rgba(0, 242, 61, 0.45);
  border-radius: 8px;
  padding: 0px 15px;
  background: rgba(0, 168, 45, 0.35);
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}

.auth-action-btn {
  min-height: 36px !important;
  width: min(100%, 14rem);
  margin-left: auto;
  margin-right: auto;
  border-radius: 18px !important;
  border: none !important;
  color: #fff !important;
  font-size: 0.82rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em;
  box-shadow:
    0 0 0 2px rgba(0, 0, 0, 0.22),
    0 4px 14px rgba(0, 168, 45, 0.35) !important;
}

.auth-action-btn--primary {
  background: linear-gradient(135deg, #00a82d 0%, #00f23d 55%, #19ff57 100%) !important;
}

.auth-action-btn--secondary {
  width: min(100%, 11rem);
  background: linear-gradient(135deg, #163a24 0%, #0d5c2e 55%, #00a82d 100%) !important;
  color: #eaffef !important;
}

.auth-action-btn--quick {
  min-height: 36px !important;
  width: min(100%, 11rem);
  background: linear-gradient(135deg, #fff59d 0%, #ffe033 40%, #ffd000 100%) !important;
  color: #14321c !important;
  box-shadow:
    0 0 0 2px rgba(255, 229, 102, 0.35),
    0 4px 14px rgba(255, 208, 0, 0.4) !important;
}

.auth-action-btn--quick-icon {
  width: 2.6rem !important;
  min-width: 2.6rem !important;
  min-height: 2.6rem !important;
  padding: 0 !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}

.auth-action-btn--quick-icon .fa-bolt {
  margin: 0;
  font-size: 1.05rem;
}

.auth-secondary-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
}

.auth-secondary-row .auth-action-btn--primary {
  margin: 0 !important;
  width: auto;
  min-width: 10rem;
}

.auth-contact-wrap {
  margin-top: 1.25rem;
  padding-top: 0.25rem;
}

.auth-contact__hint {
  margin: 0 0 0.65rem;
  text-align: center;
  color: rgba(0, 242, 61, 0.75);
  font-size: 0.78rem;
  font-weight: 500;
}

.auth-contact-row {
  width: 100%;
}

.auth-contact-col {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.auth-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.65rem 0.35rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 242, 61, 0.35);
  background: rgba(255, 255, 255, 0.06);
  text-decoration: none;
  text-align: center;
  flex-direction: column;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.auth-contact:active {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(0, 242, 61, 0.55);
  text-decoration: none;
}

.auth-contact__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.25rem;
}

.auth-contact__icon--viber {
  background: #7360f2;
  color: #ffffff;
}

.auth-contact__icon--telegram {
  background: #229ed9;
  color: #ffffff;
}

.auth-contact__title {
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}
</style>
